import type { User } from '../contexts/UserContext'

/** Where a signed-in user lands: after login, and when visiting `/`. */
export function homePathFor(user: Pick<User, 'role'> | null): string {
  switch (user?.role) {
    case 'leader':
      return '/exec'
    case 'vendor_admin':
    case 'vendor_user':
      return '/submit'
    case 'reviewer':
      return '/review'
    default:
      return '/home'
  }
}
